module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/torino.70da4e074e22a1acb47371c80d800233.jpg";